import { Draft } from 'immer';
import { CarePhase } from '../../appModel';
import { isProfessional } from '../../isProfessional';
import { usesFamilyCaregivingStep } from '../../careEnvironmentCapabilities';
import { resolveUseClaimProjectionEngine } from '../utils/resolveUseClaimProjectionEngine';
import type { ClientDerivativeOptions } from '../calcClientDerivatives';

export function calcSupportProviderDerivatives(
  mutableClient: Draft<Client>,
  options: ClientDerivativeOptions = {},
) {
  const { appliedCareEnvironments } = mutableClient;
  const useClaimProjectionEngine = resolveUseClaimProjectionEngine(mutableClient, options);

  mutableClient.supportProviderSet.supportProviders.forEach(supportProvider => {
    const [applyPhaseOne, applyPhaseTwo, applyPhaseThree] =
      applyHoursToSupportProvider(supportProvider);

    supportProvider.supportProviderAllPhaseCareHours =
      (supportProvider.supportProviderAppliedPhaseOneHours = applyPhaseOne
        ? supportProvider.supportProviderPhaseOneHours
        : 0) +
      (supportProvider.supportProviderAppliedPhaseTwoHours = applyPhaseTwo
        ? supportProvider.supportProviderPhaseTwoHours
        : 0) +
      (supportProvider.supportProviderAppliedPhaseThreeHours = applyPhaseThree
        ? supportProvider.supportProviderPhaseThreeHours
        : 0);
  });

  function applyHoursToSupportProvider(
    supportProvider: SupportProvider,
  ): [boolean, boolean, boolean] {
    if (isProfessional(supportProvider)) {
      return [true, true, true];
    }

    // This flag is not used anymore, but leaving it here for now.
    // if (removeFamilyBurden) {
    //   return [ false, false, false ];
    // }

    // Family caregiving applies for home care and — under the claim-projection
    // engine — Independent Living (home-style care the family can offset). Every
    // other facility bundles care into a flat rate with no family offset, so
    // family hours stay unapplied there. Engine off ⇒ home-only (legacy).
    return [
      usesFamilyCaregivingStep(
        appliedCareEnvironments[CarePhase.earlyCare],
        useClaimProjectionEngine,
      ),
      usesFamilyCaregivingStep(
        appliedCareEnvironments[CarePhase.moderateCare],
        useClaimProjectionEngine,
      ),
      usesFamilyCaregivingStep(
        appliedCareEnvironments[CarePhase.fullCare],
        useClaimProjectionEngine,
      ),
    ];
  }
}
